import store from '../store'

import { namespace, types } from '../store/modules/common-store'

function checkEnvironment() {
  let windowWidth = $(window).width()
  store.commit(`${namespace}/${types.SET_WINDOW_WIDTH}`, windowWidth)
  store.commit(`${namespace}/${types.SET_MOBILE}`, windowWidth <= 768)

  let isMobile = store.state[namespace].isMobile

  if (isMobile) {
    document.body.classList.remove('is_pc')
    document.body.classList.add('is_m')
  } else {
    document.body.classList.remove('is_m')
    document.body.classList.add('is_pc')
  }
}

if (mode === 'homepage') {
  checkEnvironment()
}
window.addEventListener('load', checkEnvironment)
window.addEventListener('resize', checkEnvironment)
